module.exports = __webpack_public_path__ + "static/media/1cs.b0537b6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1cs.svg
// module id = 381
// module chunks = 0